<template>
    <div>
        <h2>Business Location Type</h2>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>